'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    $('input[type="password"]').on('input', function() {
        console.log('Input');
        var button = $(this).siblings('.js-show-password');
        button.toggleClass('d-none', $(this).val().length === 0);
    });

    processInclude(require('eminence/login/login'));
    processInclude(require('eminence/components/passwordShow'));
    processInclude(require('eminence/components/passwordRequirements'));
});
